import { EntityType } from "./Entities";

export class EntityTypeEditorScreenData {

    entityType: EntityType;
    available_extra_types:Array<Object>;
    snackbar: Object;
    loading: boolean;
    available_workflows: {
        create_update: Array<Object>;
        get: Array<Object>;
        delete: Array<Object>;
        filter: Array<Object>;
    };
    crudSlotSchemas: {
        filter: Object | null;
        create_update: Object | null;
        get: Object | null;
        delete: Object | null;
    };

    constructor(){
        this.entityType = null
        this.snackbar = {
            ['isVisible']: false,
            text: '',
            color: '',
            timeout: 3000,
        }
        this.available_extra_types = []
        this.loading = false
        this.available_workflows = {
            create_update: [],
            get: [],
            delete: [],
            filter: []
        }
        this.crudSlotSchemas = {
            filter: null,
            create_update: null,
            get: null,
            delete: null
        }
    }

    success_message(message:string){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'success'
        this.snackbar['isVisible'] = true
    }

    error_message(message:string){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'error'
        this.snackbar['isVisible'] = true
    }


}